import { apiEndpoints } from './common'

import { get } from '../request'
import { sentryLogger } from '../sentry'

// Drop empty filter values rather than sending `?centre=&overall=`, which the
// backend would otherwise have to defend against on every param.
const clean = (params = {}) =>
  Object.fromEntries(
    Object.entries(params).filter(([, v]) => v !== '' && v != null)
  )

const getCsatResponses = async (params = {}) => {
  try {
    const response = await get(apiEndpoints.csatResponses, {
      params: clean(params)
    })
    return response.data
  } catch (error) {
    sentryLogger(error, 'getCsatResponses')
    throw error
  }
}

const getCsatSummary = async (params = {}) => {
  try {
    const response = await get(apiEndpoints.csatSummary, {
      params: clean(params)
    })
    return response.data
  } catch (error) {
    sentryLogger(error, 'getCsatSummary')
    throw error
  }
}

// Centre and category options come from the data, so the dropdowns cannot drift
// out of step with what actually exists. Fetched once on mount, not per filter
// change — the contents only move when a subject or centre is added.
const getCsatFilterOptions = async () => {
  try {
    const response = await get(apiEndpoints.csatFilterOptions)
    return response.data
  } catch (error) {
    sentryLogger(error, 'getCsatFilterOptions')
    throw error
  }
}

export { getCsatResponses, getCsatSummary, getCsatFilterOptions }
